// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"98e45ef2","848":"712b2f90"}[chunkId] + ".chunk.css";
};